export const NUMBER_INPUT_REGEX_TWO_DECIMALS = new RegExp(
  /^([0-9]{1,100}\.[0-9]{1,2})$|^([0-9]{1,100})\.?$|^\.([0-9]{1,2})?$/,
);
export const NUMBER_INPUT_REGEX_FOUR_DECIMALS = new RegExp(
  /^([0-9]{1,100}\.[0-9]{1,4})$|^([0-9]{1,100})\.?$|^\.([0-9]{1,4})?$/,
);
export const NUMBER_INPUT_REGEX = new RegExp(`^([0-9]+\\.{0,1}[0-9]*)$|^([0-9])*$`);
export const UNSIGNED_INTEGER_REGEX = new RegExp(`^[0-9]+$`);
export const SIGNED_INTEGER_REGEX = new RegExp(/^-?((\d+(\.\d*)?)|(\.\d+)|())$/);
export const getNumberRegex = (decimals: number) => new RegExp(`^\\d{0,100}\\.\\d{0,${decimals}}$|^[0-9]+$`);
export const NUMBER_INPUT_REGEX_ALLOW_LEADING_DOT = new RegExp(
  /^(?:\d+\.?\d*|\.\d*)?$/
);
